import React, { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import Icon from "@/components/Icon";
import AdminLayout from "@/components/AdminLayout";

const TABS = ["pending", "approved", "rejected", "spam", "all"];

export default function AdminBlogComments() {
  const [status, setStatus] = useState("pending");
  const [data, setData] = useState(null);

  const load = useCallback(() => {
    api.get("/admin/blog/comments", { params: { status } }).then(({ data }) => setData(data)).catch(() => {});
  }, [status]);
  useEffect(() => { load(); }, [load]);

  const moderate = async (id, s) => {
    try { await api.post(`/admin/blog/comments/${id}/moderate`, { status: s }); toast.success(`Marked ${s}`); load(); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };
  const del = async (id) => { if (!window.confirm("Delete this comment?")) return; await api.delete(`/admin/blog/comments/${id}`); toast.success("Deleted"); load(); };

  return (
    <AdminLayout title="Blog Comments" subtitle="Moderate visitor comments before they appear publicly">
      <div className="flex gap-2 mb-4 flex-wrap">
        {TABS.map((t) => (
          <button key={t} data-testid={`comments-tab-${t}`} onClick={() => setStatus(t)} className={`rounded-xl px-3 py-1.5 text-sm font-semibold capitalize border ${status === t ? "border-primary bg-primary text-primary-foreground" : "border-border hover:bg-accent"}`}>
            {t}{data?.counts && t !== "all" && data.counts[t] != null ? ` (${data.counts[t]})` : ""}
          </button>
        ))}
      </div>
      {!data ? <div className="grid place-items-center py-20"><Icon name="Loader2" className="h-7 w-7 animate-spin text-primary" /></div> : (
        <div className="space-y-3" data-testid="comments-list">
          {data.items.length === 0 && <div className="rounded-2xl border border-dashed border-border py-16 text-center text-muted-foreground">No {status} comments.</div>}
          {data.items.map((c) => (
            <div key={c.id} data-testid={`comment-${c.id}`} className="rounded-2xl border border-border bg-card p-4">
              <div className="flex items-start justify-between gap-3">
                <div className="min-w-0">
                  <div className="text-sm font-semibold">{c.name} <span className="text-xs text-muted-foreground font-normal">· {c.email || "no email"} · on “{c.post_title}”</span></div>
                  <p className="text-sm mt-1 text-foreground/90 whitespace-pre-wrap break-words">{c.message}</p>
                  <div className="text-xs text-muted-foreground mt-1.5">{new Date(c.created_at).toLocaleString()} · <span className="capitalize">{c.status}</span></div>
                </div>
                <div className="flex gap-1 shrink-0">
                  {c.status !== "approved" && <button data-testid={`approve-${c.id}`} onClick={() => moderate(c.id, "approved")} title="Approve" className="h-8 w-8 grid place-items-center rounded-lg border border-emerald-500/40 text-emerald-500 hover:bg-emerald-500/10"><Icon name="Check" className="h-4 w-4" /></button>}
                  {c.status !== "rejected" && <button data-testid={`reject-${c.id}`} onClick={() => moderate(c.id, "rejected")} title="Reject" className="h-8 w-8 grid place-items-center rounded-lg border border-amber-500/40 text-amber-500 hover:bg-amber-500/10"><Icon name="X" className="h-4 w-4" /></button>}
                  {c.status !== "spam" && <button data-testid={`spam-${c.id}`} onClick={() => moderate(c.id, "spam")} title="Spam" className="h-8 w-8 grid place-items-center rounded-lg border border-border hover:bg-accent"><Icon name="Ban" className="h-4 w-4" /></button>}
                  <button data-testid={`delete-${c.id}`} onClick={() => del(c.id)} title="Delete" className="h-8 w-8 grid place-items-center rounded-lg border border-red-500/40 text-red-500 hover:bg-red-500/10"><Icon name="Trash2" className="h-4 w-4" /></button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </AdminLayout>
  );
}
